/** Same delay as a correct-answer reveal before advancing (solo + PvP Witc). */
export const WITC_REVEAL_DELAY_MS = 1000;

/** Mirrors backend WitcAnswerNormalizer.PickExpectedAnswer — pt → PT string, else EN. */
export function pickExpectedWitcAnswer(
  correctPt: string | null | undefined,
  correctEn: string | null | undefined,
  userLanguage: string | undefined
): string {
  const lang = userLanguage?.trim().toLowerCase() ?? 'en';
  if (lang.startsWith('pt')) {
    return (correctPt && correctPt.trim()) || (correctEn ?? '').trim();
  }
  return (correctEn && correctEn.trim()) || (correctPt ?? '').trim();
}
